<template>
  <div
    class="fixed top-0 left-0 flex justify-between w-full py-4 px-8 bg-white z-50 shadow-default"
  >
    <img class="w-[145px] h-11" src="../../assets/logo.jpg" alt="logo" />
    <div class="flex items-center">
      <p class="mr-4 text-neutral-125">Hi, {{ props.username }}</p>
      <div
        ref="iconRef"
        class="flex justify-center items-center cursor-pointer"
      >
        <BurgerMenuIcon v-show="!topMenuVisible" />
        <CloseBurgerMenuIcon v-show="topMenuVisible" />
      </div>
    </div>

    <div
      ref="menuRef"
      v-show="topMenuVisible"
      class="absolute top-16 right-8 flex flex-col gap-2 p-4 rounded-bl-md bg-white z-10 shadow-default"
    >
      <TopMenuIcon :name="TopMenuItems.NOTES" title="Developer notes" @click="handleClick" />
      <TopMenuIcon :name="TopMenuItems.CLEAR" title="Clear cache" @click="handleClick" />
      <TopMenuIcon :name="TopMenuItems.LOGOUT" title="Logout" @click="handleClick" />
      <TopMenuIcon :name="TopMenuItems.LOGS" title="Payment Gateway Logs" @click="handleClick" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import BurgerMenuIcon from "../icons/BurgerMenuIcon.vue";
import CloseBurgerMenuIcon from "../icons/CloseBurgerMenuIcon.vue";
import TopMenuIcon from "./TopMenuIcon.vue";

enum TopMenuItems {
  NOTES = 'notes',
  CLEAR = 'clear',
  LOGOUT = 'logout',
  LOGS = 'logs',
}

interface PropsI {
  username: string | null;
}

const props = defineProps<PropsI>();
const emit = defineEmits(["info"]);

const router = useRouter();

const topMenuVisible = ref<boolean>(false);
const menuRef = ref<HTMLElement | null>(null);
const iconRef = ref<HTMLElement | null>(null);

const handleClickOutside = (event: MouseEvent) => {
  if (!event.target) {
    return;
  }

  if (iconRef.value?.contains(event.target as HTMLElement)) {
    topMenuVisible.value = !topMenuVisible.value;
    return;
  }

  if (!menuRef.value?.contains(event.target as HTMLElement)) {
    topMenuVisible.value = false;
    return;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

const menuActions: Record<TopMenuItems, () => void> = {
  [TopMenuItems.LOGOUT]: () => router.push('/logout'),
  [TopMenuItems.NOTES]: () => window.open('https://support.resrequest.com/developer/resnova-back-office-setup/', '_blank'),
  [TopMenuItems.CLEAR]: () => emit("info", "Cache cleared!"),
  [TopMenuItems.LOGS]: () => router.push('/payment-gateway-logs'),
};

const handleClick = (name: TopMenuItems) => {
  const action = menuActions[name];
  if (action) {
    action();
    topMenuVisible.value = false;
  }
};
</script>
